// extracted by mini-css-extract-plugin
export default {"componentDetailCheckbox":"rawDataForAnEntity_componentDetailCheckbox__gf+IV"};